import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppContext } from "../AppProvider/AppProvider";

export default function ProtectedRoute({ children, requiredRole }) {
  const isLoggedIn = localStorage.getItem("loggedIn") === "true";
  const userRole = localStorage.getItem("userRole");
  const { loggedIn, setLoggedIn, user, setUser, useIAP, clientClassName, setClientClassName } = useAppContext();

  if (user.role === "admin" || userRole === "admin") {
    return children;
  }

  if (requiredRole && (user.role !== requiredRole || userRole !== requiredRole) ) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
